<template>
    <div>
        <div class="bg-grey vh-100" id="list_pembayaran">
            <!-- HEADER -->
            <div class="header-top bg-white">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left" @click="backToData">
                        <div class="header-item">
                            <img src="../../assets/icons/back-blue.svg" alt="a">
                        </div>
                    </div>
                    <div class="header-top--middle f-cont f-16 f-bold">Cadangkan Layanan Reguler</div>
                    <div class="header-top--right" >
                        <div class="header-item">
                            <!--                            <img src="../../../assets/icons/search.svg" alt="">-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="showPageDefault">
                <!-- CONTENT -->
                <div class="content-wrapper main-page">

                    <div class="p-x-20 p-y-16 w-limit" v-if="leght_data_outlet===0">
                        <!-- IF EMPTY -->
                        <div class="empty-state">
                            <div class="empty-state--icon"></div>
                            <div class="f-16 f-bold">Belum ada outlet</div>
                            <div class="f-14 f-c-midgrey">Kamu tidak mempunyai outlet</div>
                        </div>
                    </div>
                    <!-- ITEMS -->
                    <div class="p-x-20 p-y-16 w-limit" v-else>

                        <div class="d-flex justify-content-between m-d-16">
                            <div class="f-16 f-c-midgrey">Total {{leght_data_outlet}} Outlet</div>
                        </div>
                        <!-- LIST ITEMS -->
                        <div class="set-card" v-for="(o,index) in outlet" :key="o.idoutlet"
                             v-bind:class="{nonActiveOutlet:o.sec_active!==2}"  >
                            <div class="overloading" v-if="o.onprogress">
                                <div class="overloading-text animated pulse infinite" >Mohon tunggu, sedang memproses {{o.progress_looping}} dari {{o.lenght}} Data </div>
                            </div>
                            <div class="row add-padding-default" @click="exportLayananBackground(o.idoutlet,index)">
                                <div class="col-lg-1 col-2   remove-margin remove-padding">
                                    <img class="" src="../../assets/gambar/Rectangle43.svg" alt=""
                                         style="width: 48px;border: 1px solid #E1E5EC;box-sizing: border-box;border-radius: 3px;"
                                         v-if="o.logo_url===''"
                                    >
                                    <img class="imgFit"
                                         v-bind:src="'https://storage.googleapis.com/ember-e-dalbo/'+ o.logo_url"
                                         alt=""
                                         v-else-if="o.logo_url.includes('bos_revamp/')">
                                    <img class="imgFit"
                                         v-bind:src="'https://res.cloudinary.com/sinadme/c_scale,h_200/'+ o.logo_url"
                                         alt="" v-else>
                                </div>

                                <div class="col-lg-10 col-md-8 col-sm-8 col-7  remove-padding">
                                    <div class="font-16 remove-margin font-weight-bold nomore capitalize">
                                        {{ o.nama }}
                                    </div>
                                    <div class="font-13 f-c-midgrey remove-margin nomore capitalize addressstyle">
                                        {{ o.total_layanan }}
                                        Layanan
                                    </div>
                                </div>

                                <div class="col-lg-1 col-md-2 col-sm-2 col-3  remove-padding text-right">
                                    <button type="button" class="btn btn-outline-primary "
                                    > Ekspor</button>

                                </div>


                            </div>

                            <div style="margin-top:5px; padding-top:5px; border-top:solid 1px #eaeaea;">
                                <div v-if="o.exportlink">
                                                        <span style="font-size: 14px; color : #A00;">
                                                        Jika file download tidak muncul secara otomatis,
                                                        </span>
                                    <br/>
                                    <a :href="o.exportlink" >Klik Download Disini</a>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </div>

    </div>


</template>
<style scoped>
    .imgFit {
        max-width: 100%;
        max-height: 100%;
    }
    .overloading {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: #686868ed;
        z-index: 9;
        text-align: center;
        color: #fff;
        padding-top: 30px;
        font-size: 14px;
    }
    .set-card{
        position: relative;
    }
</style>
<script>
    export default {
        name: "backupLayanan",
        data(){
            return{
                outlet:[],
                listCountLayanan:[],
                leght_data_outlet:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                listOutletPagination: {
                    limit: 200,
                    offset:0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "created_at",
                    orderBy: "DESC",
                },
            }
        },
        mounted() {

            this.getListOutlet();

        },
        methods:{

            backToData(){
                this.$router.push({name: "datakuy"})
            },
            async exportLayananBackground(idoutlet,index) {
                this.outlet[index].onprogress=1
                this.$set(this.outlet,index,this.outlet[index])

                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/layanan/export_layanan_excel?idoutlet=' + idoutlet, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            let that=this
                            this.outlet[index].timerprogress=setInterval(function () {
                                that.checkExportLayananBackground(idoutlet,index);
                            },2000)
                            // this.deleteStorage(filenameStorage);

                        } else {
                            this.outlet[index].onprogress=0
                        }
                    }
                    this.$set(this.outlet,index,this.outlet[index])

                } catch (e) {
                    this.$catch_error_response(e)
                    this.outlet[index].onprogress=0
                    this.$set(this.outlet,index,this.outlet[index])
                }
            },
            async checkExportLayananBackground(idoutlet,index) {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/layanan/track_export_layanan?idoutlet=' + idoutlet, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var dataprogress = response.data.data;
                            this.outlet[index].progress_looping=dataprogress.progress_looping
                            this.outlet[index].lenght=dataprogress.lenght_data

                            if(dataprogress.status_progress==="1"){

                                this.outlet[index].onprogress=0

                                window.clearInterval(this.outlet[index].timerprogress);
                                var filenameStorage = response.data.data.filename
                                var linkStorage = response.data.data.link_url
                                linkStorage = linkStorage.replace(filenameStorage,encodeURIComponent(filenameStorage));
                                window.open(linkStorage, "_blank");

                                // this.deleteStorage(filenameStorage);
                                this.outlet[index].exportlink=linkStorage

                            }
                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    }

                    this.$set(this.outlet,index,this.outlet[index])


                } catch (e) {
                    this.$catch_error_response(e)
                }
            },

            async exportLayanan(idoutlet,index) {
                this.outlet[index].onprogress=1
                this.$set(this.outlet,index,this.outlet[index])

                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/layanan/direct_export_layanan?idoutlet=' + idoutlet, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var filenameStorage = response.data.data.filename
                            var linkStorage = response.data.data.link_file_storage
                            linkStorage = linkStorage.replace(filenameStorage,encodeURIComponent(filenameStorage));
                            window.open(linkStorage, "_blank");
                            // this.deleteStorage(filenameStorage);
                            this.outlet[index].exportlink=linkStorage
                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    }

                    this.outlet[index].onprogress=0
                    this.$set(this.outlet,index,this.outlet[index])

                } catch (e) {
                    this.$catch_error_response(e)
                    this.outlet[index].onprogress=0
                    this.$set(this.outlet,index,this.outlet[index])
                }
            },
            async deleteStorage(filename) {
                try {
                    var formData = new FormData()
                    formData.append("filename", filename)

                    const response = await this.$axios.post(this.$baseurl + '/masterData/layanan/delete_file_export_layanan?filename=' + filename, formData, this.requestHeaders)
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getLayananCount(idoutlet,index){

                    try {
                        const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_count_component_outlet?idoutlet=' + idoutlet, this.requestHeaders);
                        this.outlet[index].total_layanan=response.data.data.layanan
                        this.$set(this.outlet,index,this.outlet[index])
                    } catch (e) {
                        this.outlet[index].total_layanan="Gagal mengambil"
                        this.$set(this.outlet,index,this.outlet[index])

                    }
            },
            async getListOutlet(refresh = false){
                if (refresh) {
                    this.outlet = [];
                    this.listOutletPagination = {
                        limit: 20,
                        offset:0,
                        length: 0,
                        pageNumber: 0,
                        sortBy: "created_at",
                        orderBy: "DESC",
                    }
                }
                if (this.listOutletPagination.offset === 0) {
                    this.outlet = [];
                    $('#loadingPage').addClass('overlayLoading');
                    $('#loadingPage').show()
                }
                try {
                    var idowner = localStorage.getItem('idowner');
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_sorting_meta?idowner='+idowner
                        +'&sort_by=' + this.listOutletPagination.sortBy
                        + '&order_by='+ this.listOutletPagination.orderBy
                        + '&limit=' + this.listOutletPagination.limit
                        + '&offset=' + this.listOutletPagination.offset, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        var pembayaranlist = response.data.data;
                        this.listOutletPagination.length += pembayaranlist.length
                        this.leght_data_outlet=response.data.lenght_data;
                        this.outlet.push(...pembayaranlist)
                        for (let i = 0; i <pembayaranlist.length ; i++) {
                            this.getLayananCount(pembayaranlist[i].idoutlet,i)
                        }

                        this.listOutletPagination.pageNumber++
                        $('#loadingSpinnerListOutlet').hide()
                    }
                }  catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked = false
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                    $('#textBtn2').show()
                    $('#btnNext').prop('disabled', false);
                }
            },

        }
    }
</script>

